import axios from "axios";
import { Config } from "../../config/config";

interface HeartBeatResponse {
    success: boolean;
    data?: any;
    error?: any;
}

export const heartBeat = (cookie) =>
    new Promise<HeartBeatResponse>((resolve) => {
        if (!cookie) {
            return resolve({ success: false });
        }

        // Let's try to login
        axios.post(`${Config.getInstance.apiUrl}/api/heartbeat`, {
            token: cookie,
        }).then((result) => {
            resolve(result.data);
        }).catch(error => {

            resolve({ success: false, error });
        });
    });
